;(function() {
  'use strict'

  config.$inject = ["$stateProvider"];
  var dependencies = []

  angular.module('app.home', dependencies).config(config)

  /* @ngInject */
  function config($stateProvider) {
    $stateProvider.state('app.home', {
      url: '/?{enquiry:bool}',
      templateUrl: 'home.template.html',
      controller: 'Home',
      title: 'Glow',
      hide: true,
    })

    // TODO:
    // remove this state definition when the /pro route gets no hits
    // we switched the pro route to be the root route May-15-2017

    $stateProvider.state('app.pro', {
      url: '/pro?{enquiry:bool}',
      templateUrl: 'home.template.html',
      controller: 'Home',
      title: 'Business',
      hide: true,
    })

    // TODO
    // remove the following state when google-analytics has no hits.
    // we switched to the /pro route Oct-26-2016

    $stateProvider.state('app.business', {
      url: '/business?{enquiry:bool}',
      templateUrl: 'home.template.html',
      controller: 'Home',
      title: 'Business',
      hide: true,
    })
  }
})()
